import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Updates {@link localStorage} when polling is toggled via `togglePolling`
 * action
 */
export const updateLocalStorageOnToggle = store.effects.create(
  (feature: Plugin['feature'], localStorage: Plugin['localStorage']) =>
    feature.actions.togglePolling.observe().pipe(
      rxjs.withLatestFrom(localStorage.selectors.isStarted.asObservable),
      rxjs.map(([action, isStarted]) =>
        localStorage.actions.setIsStarted.from(action).create(!isStarted),
      ),
    ),
)
